/* eslint-disable linebreak-style */
import { Routes, Route } from 'react-router-dom';
import { ExpertHubLayout } from 'components/templates';
import ProfileView from './components/profile-view';
import ProfileUpdate from './components/profile-update';
import ProfileMessage from './components/profile-message';

const ProfileBase = () => (
  <ExpertHubLayout>
    <Routes>
      <Route path="/" element={<ProfileView />} />
      <Route path="/update" element={<ProfileUpdate />} />
      <Route path="/message" element={<ProfileMessage />} />
    </Routes>
  </ExpertHubLayout>
);

export default ProfileBase;
